import { render, staticRenderFns } from "./cancel-booking-preloader.vue?vue&type=template&id=3ae1ae64&scoped=true"
import script from "./cancel-booking-preloader.vue?vue&type=script&lang=ts&setup=true"
export * from "./cancel-booking-preloader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./cancel-booking-preloader.vue?vue&type=style&index=0&id=3ae1ae64&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae1ae64",
  null
  
)

export default component.exports